import { Trophy, Flame, Target } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-36 relative"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top intro */}
        <div className="grid lg:grid-cols-12 gap-12 items-center mb-24">
          <div className="lg:col-span-5 relative">
            <div
              className="bento-corner relative aspect-[4/5] overflow-hidden bg-black"
              role="img"
              aria-label="Roc May — the athlete behind OMNIMUSCLE"
              style={{
                backgroundImage:
                  "url(https://customer-assets.emergentagent.com/job_omni-brand-1/artifacts/1eyb5eb6_IMG_20190502_061550_548%20-%20Copy.jpg)",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "82% 38%",
                backgroundSize: "210%",
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-tr from-[#4C1D95]/35 via-transparent to-transparent pointer-events-none" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#D4AF37] text-black px-6 py-4 hidden md:block">
              <div className="font-display text-3xl leading-none">EST. 2018</div>
              <div className="font-accent text-xs uppercase tracking-widest">Iron Forged</div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="text-[#D4AF37] font-accent text-xs uppercase tracking-[0.3em] mb-4">
              Meet Roc May ·{" "}
              <span className="font-bold" style={{ color: "#4C1D95", WebkitTextStroke: "0.4px #D4AF37" }}>
                @OmniMuscle
              </span>
            </div>
            <h2 className="font-display text-5xl md:text-7xl text-white leading-[0.9] mb-6">
              I'm <span className="text-[#D4AF37]">Roc</span> —
              <br />
              The Athlete
              <br />
              Behind The Brand.
            </h2>
            <p className="text-lg text-neutral-300 leading-relaxed mb-5 max-w-2xl">
              I'm a competitive bodybuilder, performance coach, and supplement
              formulator. Every program, every stack, every rep recommendation
              under the OMNIMUSCLE banner has been{" "}
              <span className="text-white font-semibold">
                tested under the bar
              </span>{" "}
              before it's offered to you.
            </p>
            <p className="text-base text-neutral-400 leading-relaxed mb-10 max-w-2xl">
              No shortcuts. No fluff. Just protocols that build symmetry,
              density, and the kind of presence that turns heads on stage and
              on the street. If you're done playing small with your physique —
              you're in the right place.
            </p>

            <div className="grid sm:grid-cols-3 gap-4">
              {[
                { icon: Trophy, t: "Competitive", s: "NPC & IFBB stage tested" },
                { icon: Flame, t: "Hypertrophy", s: "Density-first programming" },
                { icon: Target, t: "Precision", s: "Macro & micro dialed" },
              ].map((b) => (
                <div
                  key={b.t}
                  data-testid={`about-pillar-${b.t}`}
                  className="omni-card p-5"
                >
                  <b.icon size={28} className="text-[#D4AF37] mb-3" />
                  <div className="font-display text-xl text-white">{b.t}</div>
                  <div className="text-sm text-neutral-400 mt-1">{b.s}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
